var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnapproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18583",
    "data-name": "Group 18583",
    transform: "translate(-75 -227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_42665",
    "data-name": "Rectangle 42665",
    transform: "translate(75 227)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "cancel_schedule_send_FILL0_wght400_GRAD0_opsz24",
    d: "M127.976-789.9l1.142-1.142,1.142,1.142.489-.489-1.125-1.126,1.142-1.142-.489-.489-1.142,1.142-1.142-1.142-.489.489,1.142,1.142-1.142,1.142Zm-7.976.343V-800l9.33,3.915h-.2a4.292,4.292,0,0,0-1.077.131,5.273,5.273,0,0,0-.979.359l-5.774-2.447v2.283l3.915.979-3.915.979v2.283l3.523-1.5a4.832,4.832,0,0,0-.2.742,4.323,4.323,0,0,0-.065.758v.033Zm9.134,1.3a3.144,3.144,0,0,1-2.308-.954,3.144,3.144,0,0,1-.954-2.308,3.144,3.144,0,0,1,.954-2.308,3.144,3.144,0,0,1,2.308-.954,3.144,3.144,0,0,1,2.308.954,3.144,3.144,0,0,1,.954,2.308,3.144,3.144,0,0,1-.954,2.308A3.144,3.144,0,0,1,129.134-788.256Zm-7.829-4.763v0Z",
    transform: "translate(-43.198 1029.128)",
    fill: "#fabd4d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnapproved);
export default __webpack_public_path__ + "static/media/unapproved.08149e926abff51e90d053d166e868a2.svg";
export { ForwardRef as ReactComponent };